import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import PricingListComponent from './PricingListComponent';

import {getRoute, RouteSection} from '~/utils/route';
import {useDebounce} from '~/modules/frontdesk/hooks';

import {RoutePath} from '~/constants/routes';

const PricingListContainer = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const debouncedSearchTerm = useDebounce<string>(searchText, 500);

  const toggleIsModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleBackClick = () => {
    navigate(
      getRoute(RouteSection.Finance, RoutePath.staff.finance.dashboard.index)
    );
  };

  const handleCloseClick = () => {
    toggleIsModalOpen();
  };

  const handleNewPriceClick = () => {
    toggleIsModalOpen();
  };

  return (
    <>
      <PricingListComponent
        handleBackClick={handleBackClick}
        handleNewPriceClick={handleNewPriceClick}
        isModalOpen={isModalOpen}
        handleCloseClick={handleCloseClick}
        searchText={searchText}
        debouncedSearchTerm={debouncedSearchTerm}
        setSearchText={setSearchText}
      />
    </>
  );
};

export default PricingListContainer;
